/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Dashboard_Stats_Totalrevenue1Inputs */

const he_dashboard_stats_totalrevenue1 = /** @type {(inputs: Dashboard_Stats_Totalrevenue1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`הכנסות כוללות`)
};

const en_dashboard_stats_totalrevenue1 = /** @type {(inputs: Dashboard_Stats_Totalrevenue1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Total Revenue`)
};

/**
* | output |
* | --- |
* | "Total Revenue" |
*
* @param {Dashboard_Stats_Totalrevenue1Inputs} inputs
* @param {{ locale?: "he" | "en" }} options
* @returns {LocalizedString}
*/
const dashboard_stats_totalrevenue1 = /** @type {((inputs?: Dashboard_Stats_Totalrevenue1Inputs, options?: { locale?: "he" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dashboard_Stats_Totalrevenue1Inputs, { locale?: "he" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "he") return he_dashboard_stats_totalrevenue1(inputs)
	return en_dashboard_stats_totalrevenue1(inputs)
});
export { dashboard_stats_totalrevenue1 as "dashboard_stats_totalRevenue" }